export const SL_RATE_LIMITING_V3 = 'sl_rate_limiting_v3';
export const SL_WEB_TEST_MANAGER = 'sl_web_test_manager';
export const SL_IOS_WEB_SPOT_CONDITION_COLORS = 'SL_ios_web_spot_condition_colors';
